import { env } from "environment-interface/env";
import { useCopyToClipboard } from "features/common/useCopyToClipboard";
import { Box, Button, Stack } from "prism-react";

import { VersionList } from "../VersionList";

type Version = [string, string | undefined];
type ValidVersion = [string, string];

interface VersionDetailsProps {
  versions?: Version[];
}

export const VersionDetails: React.FC<VersionDetailsProps> = ({
  versions = [],
}) => {
  const copy = useCopyToClipboard();

  const validVersions = [
    ["Version", env.PUBLIC_VERSION],
    ["Environment", env.PUBLIC_ENVIRONMENT],
    ...versions,
  ].filter((item): item is ValidVersion => item[1] !== undefined);

  return (
    <Box
      css={{
        width: "100%",
        alignItems: "flex-start",
      }}
      selectable
    >
      <Stack gap={6}>
        <VersionList>
          {validVersions.map(([name, version]) => (
            <VersionList.Item
              key={`version-list-item-${name}`}
              name={name}
              version={version}
            />
          ))}
        </VersionList>

        <Button
          css={{ alignSelf: "flex-start" }}
          icon="copy"
          iconPosition="right"
          onClick={() =>
            copy(
              validVersions
                .map(([name, version]) => `${name}: ${version}`)
                .join("\n"),
            )
          }
          variant="primary"
        >
          Copy
        </Button>
      </Stack>
    </Box>
  );
};
